import _styled from '@emotion/styled/base';

const TrimmedWrapper = _styled("div", {
  target: "epkd0g73"
})("position:relative;white-space:nowrap;width:100%;", ({
  maxWidth
}) => maxWidth && `max-width: ${maxWidth};`, ";");
const FullHiddenText = _styled("div", {
  target: "epkd0g72"
})({
  name: "p652sy",
  styles: "position:absolute;visibility:hidden;width:100%"
} );
const EllipsedText = _styled("div", {
  target: "epkd0g71"
})(({
  ellipsis
}) => ellipsis && `text-overflow: ellipsis;`, " overflow:hidden;");
const LimitTextLengthWrapper = _styled("span", {
  target: "epkd0g70"
})(({
  withFixedChars
}) => withFixedChars ? 'display: inline-block' : 'width: 100%;', " ", ({
  isOverflowing
}) => isOverflowing && `> span { width: 100%; }`, ";");

export { EllipsedText, FullHiddenText, LimitTextLengthWrapper, TrimmedWrapper };
